/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, identity, RestSettings } from '@gh/core-data';

import { Observable } from 'rxjs';
import { ScheduleType } from '@gh/builder-shared-data';
import { ID } from '@gh/common-shared-data';
import { API_BASE_URL } from '@gh/config';

@Injectable()
export class GanttChartRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  getType(type: ScheduleType): string {
    switch (type) {
      case ScheduleType.Construction:
        return 'constructions';
        break;
      case ScheduleType.Sales:
        return 'sales';
        break;
      case ScheduleType.Maintenance:
        return 'maintenances';
        break;
      case ScheduleType.PreConstruction:
        return 'pre-constructions';
        break;
      default:
        return 'constructions';
    }
  }

  updateCreateScheduleNote(scheduleType: ScheduleType, scheduleId: ID, taskId: ID, note: any): Observable<any> {
    return this.httpPut(
      `${this.bp}/schedules/${this.getType(scheduleType)}/${scheduleId}/tasks/${taskId}/note`, note, identity());
  }

  updateCreateTemplateNote(templateId: ID, taskId: ID, note: any): Observable<any> {
    return this.httpPut(`${this.bp}/schedule-templates/${templateId}/tasks/${taskId}/note`, note, identity());
  }

  printPdf(data: any): Observable<any> {
    const req = `type=pdf&data=${encodeURIComponent(JSON.stringify(data))}`;
    return  this.httpClient.post(`${API_BASE_URL}${this.pdf}`, req, {
      headers     : {
        'content-type'   : 'application/x-www-form-urlencoded',
        'accept'         : 'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.7',
        'accept-language': 'en-US,en;q=0.9,ru-RU;q=0.8,ru;q=0.7',
      },
      responseType: 'blob',
    });
  }
}
